import { THEMES } from '@/utils/themes'

export default {
  methods: {
    setTheme (theme) {
      const _theme = THEMES[theme]
      if (!_theme) {
        return
      }

      this.setColors(_theme.background, _theme.background, _theme.text)
    },

    setColors (topBg, downBg, textColor) {
      document.body.style.setProperty('--nav-background-up-color', topBg)
      document.body.style.setProperty('--nav-background-down-color', downBg)
      this.$vuetify.theme.themes.light.text = textColor
      this.$vuetify.theme.themes.dark.text = textColor
    },

    useBrandingTheme (branding) {
      if (branding && branding.theme) {
        if (branding.listener_cabinet_theme === 'custom') {
          const { sidebar_top: { bg: sidebarTopBg, fg: textColor }, sidebar_bottom: { bg: sidebarDownBg } } = branding.custom_listener_cabinet_colors || {}
          this.setColors(sidebarTopBg, sidebarDownBg, textColor)
        } else if (branding.theme === 'custom') {
          const { sidebar_selected: { bg: sidebarTopBg }, sidebar: { bg: sidebarDownBg } } = branding.custom_colors || {}
          this.setColors(sidebarTopBg, sidebarDownBg, 'white')
        } else {
          this.setTheme(branding.theme)
        }
      }
    }

  }
}
